import { palette } from './palette'
import { rgba } from 'emotion-rgba'
export const elevation = {
  1: `0px 2px 4px ${rgba(palette.black, 0.2)}`
}
